export type ReconciliationItemModel = {
    actualTotal: number,
    balanced: string,
    campaign_id: number,
    comments: string,
    date: string,
    editable: string,
    entityType: string,
    expectedTotal: number,
    id: number,
    invoice_date: string,
    invoiceNumber: string,
    invoice_notes: string,
    invoice_reference: string,
    invoice_total: number,
    itemCount: string,
    itemType: string,
    orderNumber: string,
    paid_by: number,
    provider: string,
    purchaseOrder: string,
    sort: number,
    status: string,
    title: string,
}

const state = {
  actualtotal: '',
  invoice_date: '',
  invoice_notes: '',
  invoice_reference: '',
  invoice_total: undefined,
  paid_by: '',
}

export const requiredFields = [
  { key: 'invoice_date' },
  { key: 'invoice_reference' },
]

export default state
